import Button from '@/components/Button';
import { useCart } from '@/hooks';
import { IToggleTrigger } from '@/hooks/useToggle';
import { FormattedMessage } from 'react-intl';
import { trackEvent } from '../Event/_lib/eventTrack';

interface IProps {
  emptyTrigger: IToggleTrigger;
  cartTrigger: IToggleTrigger;
}

export function CartButton({ emptyTrigger, cartTrigger }: IProps) {
  const { cartData } = useCart({});

  return (
    <div className="w-[280px] flex items-center justify-between">
      <Button
        className="!h-[60px] !w-[280px]"
        data-primary
        onClick={() => {
          trackEvent('PLP_click_Cart_button');
          if (cartData?.cart_offers.length === 0) {
            emptyTrigger.open();
            setTimeout(() => emptyTrigger.close(), 800);
          } else {
            cartTrigger.open();
          }
        }}
      >
        <span className="text-[16px] font-bold">
          <FormattedMessage id="photocard-list_cart" defaultMessage="Cart" />{' '}
          {`${cartData && (cartData.cart_offers.length as number) > 0 ? `(${cartData && cartData.cart_offers.length})` : ''}`}
        </span>
      </Button>
    </div>
  );
}
